module.exports = __webpack_public_path__ + "static/media/service1.2af41325.png";